export const getPosConsumption = (account = {}) => {
  const balance = Number(account.ammount)

  if (!Number.isFinite(balance) || balance >= 0) {
    return 0
  }

  return -balance
}
